<footer class="relative overflow-hidden border-t border-surface bg-surface-50 dark:bg-white/5">
    <div class="relative z-10 mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div class="grid gap-10 text-center sm:grid-cols-2 sm:text-start lg:grid-cols-4">
            <div>
                <div class="flex flex-wrap items-center justify-center gap-5 sm:justify-start">
                    <span class="footer-logo-icon"><app-landing-logo /></span>
                </div>
                <p class="mx-auto mt-4 max-w-xs text-sm leading-6 text-muted-color sm:mx-0">{{ text().introPresentsWord }}</p>
            </div>

            <div>
                <div class="text-sm font-semibold uppercase tracking-[0.24em] text-muted-color">{{ text().footerNavHeading }}</div>
                <nav class="mt-4 flex flex-col gap-3 text-sm">
                    <a (click)="navigate.emit('home')" class="cursor-pointer text-muted-color transition hover:text-primary">{{ text().navHome }}</a>
                    <a (click)="navigate.emit('work')" class="cursor-pointer text-muted-color transition hover:text-primary">{{ text().navWork }}</a>
                    <a (click)="navigate.emit('fit')" class="cursor-pointer text-muted-color transition hover:text-primary">{{ text().navFit }}</a>
                    <a (click)="navigate.emit('benefits')" class="cursor-pointer text-muted-color transition hover:text-primary">{{ text().navBenefits }}</a>
                    <a (click)="navigate.emit('security')" class="cursor-pointer text-muted-color transition hover:text-primary">{{ text().navSecurity }}</a>
                </nav>
            </div>

            <div>
                <div class="text-sm font-semibold uppercase tracking-[0.24em] text-muted-color">{{ text().footerResourcesHeading }}</div>
                <p class="mt-4 text-sm leading-6 text-muted-color">{{ text().footerResourcesNote }}</p>
                <ul class="mt-4 flex flex-col gap-3 text-sm">
                    @for (item of text().footerResourceItems; track item) {
                        <li class="flex items-center justify-center gap-3 text-muted-color/80 sm:justify-between">
                            <span class="flex items-center gap-2">
                                <i class="pi pi-lock text-xs"></i>
                                {{ item }}
                            </span>
                            <span class="rounded-full bg-surface-200 px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wide text-muted-color dark:bg-white/10">{{ text().footerComingSoonBadge }}</span>
                        </li>
                    }
                </ul>
            </div>

            <div>
                <div class="text-sm font-semibold uppercase tracking-[0.24em] text-muted-color">{{ text().footerContactHeading }}</div>
                <p class="mt-4 text-sm leading-6 text-muted-color">{{ text().footerContactNote }}</p>
                <button
                    type="button"
                    (click)="navigate.emit('contact')"
                    class="mt-5 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-contrast transition hover:bg-primary-600"
                >
                    {{ text().footerContactCta }}
                </button>
            </div>
        </div>

        <div class="mt-10 flex flex-col items-center gap-4 border-t border-surface pt-6 sm:flex-row sm:justify-between">
            <p class="text-xs text-muted-color">&copy; {{ currentYear }} {{ text().appName }}. {{ text().footerRightsReserved }}</p>
            <button type="button" (click)="navigate.emit('home')" class="inline-flex items-center gap-2 text-xs font-semibold text-muted-color transition hover:text-primary">
                {{ text().footerBackToTop }}
                <i class="pi pi-arrow-up text-xs"></i>
            </button>
        </div>
    </div>
</footer>
